<template>
	<div>
		<section v-if="apiStatus === 'error'">
			<h1 class="text-center">{{ errorMessage }}</h1>
		</section>
		<section v-if="apiStatus === 'failed'">
			<div class="mx-auto max-w-(--breakpoint-xl) py-8 px-4 lg:py-16 lg:px-6">
				<div class="mx-auto max-w-(--breakpoint-sm) text-center">
					<h1
						class="text-primary-600 mb-4 text-7xl font-extrabold tracking-tight lg:text-9xl"
					>
						500
					</h1>
					<p
						class="mb-4 text-3xl font-bold capitalize tracking-tight text-gray-900 md:text-4xl"
					>
						{{ getTranslations("internal server error") }}
					</p>
					<p class="mb-4 text-lg font-light normal-case">
						{{
							getTranslations(
								"we apologize for the inconvenience. our team is currently addressing the issue. please check back later. thank you for your patience and understanding"
							)
						}}
					</p>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	name: "ErrorBlock",
	props: {
		apiStatus: {
			type: String,
			required: true,
		},
		errorMessage: {
			type: String,
			default: "",
		},
		getTranslations: {
			type: Function,
			required: true,
		},
	},
};
</script>
